import React from 'react';
import styles from './ProjectItem.module.css';

const ProjectItem = ({ project }) => {
  // Logic for rendering project title (may or may not be a link)
  const renderTitle = () => {
    if (project.links && project.links.length === 1) {
      const link = project.links[0];
      return (
        <a href={link.url} target="_blank" rel="noopener noreferrer">
          {project.name}
        </a>
      );
    } else if (project.url) { // Fallback for old structure
      return (
        <a href={project.url} target="_blank" rel="noopener noreferrer">
          {project.name}
        </a>
      );
    }
    return project.name;
  };

  // Render multiple links in a horizontal layout below description
  const renderMultipleLinks = () => {
    if (project.links && project.links.length > 1) {
      return (
        <div className={styles.linkContainer}>
          {project.links.map((link, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span className={styles.linkSeparator}> </span>}
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.projectLink}
              >
                {link.text || link.url}
              </a>
            </React.Fragment>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className={styles.projectItem}>
      <h3 className={styles.projectName}>
        {renderTitle()}
      </h3>
      <p className={styles.projectDescription}>{project.description}</p>
      {renderMultipleLinks()}
    </div>
  );
};

export default ProjectItem;